// src/layouts/Pages/PageHeader/CardHeaderIcons.jsx
// *******************************************************************************
// CARD HEADER ICONS
// *******************************************************************************
// Wrapper component that displays DocumentInfoIcons in the card header.
// Delegates all icon rendering logic to DocumentInfoIcons component.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import DocumentInfoIcons from 'components/JarvislyComponents/DocumentInfoIcons';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const CardHeaderIcons = ({ data }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <DocumentInfoIcons data={data} size={18} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderIcons;